import { UiSchema } from '@rjsf/utils';
import { MODEL_TYPES, ModelType } from 'api/model';
import ListSelectionWidget from 'components/form/ListSelectionWidget';
import ModelSpecificationGroupAutocompleteWidget from 'components/form/ModelSpecificationGroupAutocompleteWidget';
import { JSONSchema7 } from 'json-schema';

const PROVIDER_DISPLAY_NAMES: Record<ModelType, string> = {
  [ModelType.OPEN_AI]: 'OpenAI',
  [ModelType.ANTHROPIC]: 'Anthropic',
  [ModelType.GOOGLE]: 'Google',
  [ModelType.VERTEX]: 'Vertex AI',
  [ModelType.BEDROCK]: 'Bedrock',
  [ModelType.PERPLEXITY]: 'Perplexity',
  [ModelType.XAI]: 'xAI',
  [ModelType.OLLAMA]: 'Ollama',
};

function getSchema(): JSONSchema7 {
  return {
    type: 'object',
    properties: {
      name: {
        title: 'Name',
        type: 'string',
        description: 'The name of the LLM model as available in the provider API.',
      },
      provider: {
        title: 'Provider',
        type: 'string',
        enum: MODEL_TYPES,
      },
      group: {
        title: 'Group',
        type: 'string',
        description: 'The group this model specification belongs to.',
      },
      description: {
        title: 'Description',
        type: 'string',
      },
      specification_name: {
        title: 'Specification Name',
        type: ['string', 'null'],
        description: 'The name of the model in the specification source, if different from the model name.',
      },
      fetch_specification: {
        title: 'Fetch Specification?',
        type: 'boolean',
        description: 'Whether to fetch the model specification from the remote source.',
        default: true,
      },
    },
    required: ['name', 'provider', 'group'],
  };
}

function getUiSchema(providerGroups: string[]): UiSchema {
  return {
    provider: {
      'ui:widget': ListSelectionWidget,
      'ui:options': {
        render: (value: ModelType) => PROVIDER_DISPLAY_NAMES[value] ?? value,
      },
    },
    group: {
      'ui:widget': ModelSpecificationGroupAutocompleteWidget,
      'ui:options': {
        autocompleteOptions: providerGroups,
      },
    },
  };
}

export { getSchema, getUiSchema };
